import generateBootFunc from '@core/generate-boot';
import resource from "@core/Util/resources";

import Index from "./Components/Composer";
import Overview from "./Components/Overview/JourneyBuilderOverview.vue";
import JourneyStatistics from './Components/JourneyStatistics.vue';

const bootIndex = generateBootFunc(Index, 'journey-builder-index');
const bootOverview = generateBootFunc(Overview, 'journey-builder-overview');

import DefaultLayout from "@core/Components/Layout/DefaultLayout.vue";

const routes = [{
    name: 'journey-overview',
    
    //TODO: Fix once we get more client side routes
    path: '/JourneyBuilder/Overview/',
    alias: '/JourneyBuilder/',
    component: DefaultLayout,
    meta: {
        isMvcRoute: true,
        breadcrumb: resource('BreadCrumb_JourneyBuilder_Overview')
    },
    children: [{
        name: 'view-statistics',
        path: 'JourneyReport/:id?',
        component: JourneyStatistics,
        meta: {
            title: resource('JourneyBuilder_JourneyStatistics_Title'),
            header: resource('JourneyBuilder_JourneyStatistics_Title'),
            breadcrumb: resource('Breadcrumb_JourneyBuilder_JourneyStatistics')
        }
    }]
}];

export {
    bootIndex,
    bootOverview,
    routes
};